import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Spinner from "../../Spinner/Spinner";
import filterFactory from "react-bootstrap-table2-filter";

export default function DataTable(props) {
  const headerStyle = props.headerStyle
    ? props.headerStyle
    : { fontSize: 10, margin: "-10px" };
  const colStyle = props.colStyle
    ? props.colStyle
    : { fontSize: 12, padding: "1px", verticalAlign: "center" };
  const [previousFilterObject, setPreviousFilterObject] = useState({});
  const [previousResult, setPreviousResult] = useState({});

  const afterFilter = (newResult, newFiltersObject) => {
    const newFiltersKeys = Object.keys(newFiltersObject);
    const previousFiltersKeys = Object.keys(previousFilterObject);
    let isObjectsSimilar = true;
    if (
      newResult.length !== previousResult.length ||
      newFiltersKeys.length !== previousFiltersKeys.length
    ) {
      isObjectsSimilar = false;
    }
    if (props.setStatusFilterValue) {
      const newValue = newFiltersObject.isActive
        ? newFiltersObject.isActive.filterVal
        : "";
      props.setStatusFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageStatusFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setAlertsFilterValue) {
      const newValue = newFiltersObject.alerts
        ? newFiltersObject.alerts.filterVal
        : "";
      props.setAlertsFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageAlertsFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setFreshWaterVolumeFilterValue) {
      const newValue = newFiltersObject.freshWaterVolume
        ? newFiltersObject.freshWaterVolume.filterVal
        : "";
      props.setFreshWaterVolumeFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageFreshWaterVolumeFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setScoreFilterValue) {
      const newValue = newFiltersObject.score
        ? newFiltersObject.score.filterVal
        : "";
      props.setScoreFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageScoreFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setRecipeFilterValue) {
      const newValue = newFiltersObject.recipe
        ? newFiltersObject.recipe.filterVal
        : "";
      props.setRecipeFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageRecipeFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setObjectNameFilterValue) {
      const newValue = newFiltersObject.objectName
        ? newFiltersObject.objectName.filterVal
        : "";
      props.setObjectNameFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageObjectNameFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setShiftFilterValue) {
      const newValue = newFiltersObject.shift
        ? newFiltersObject.shift.filterVal
        : "";
      props.setShiftFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageShiftFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setObjectGroupFilterValue) {
      const newValue = newFiltersObject.objectGroup
        ? newFiltersObject.objectGroup.filterVal
        : "";
      props.setObjectGroupFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageObjectGroupFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setStartTimeFilterValue) {
      const newValue = newFiltersObject.startTimeFormatted
        ? newFiltersObject.startTimeFormatted.filterVal
        : "";
      props.setStartTimeFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageStartTimeFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setLineFilterValue) {
      const newValue = newFiltersObject.line
        ? newFiltersObject.line.filterVal
        : "";
      props.setLineFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageLineFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setProductFilterValue) {
      const newValue = newFiltersObject.product
        ? newFiltersObject.product.filterVal
        : "";
      props.setProductFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageProductFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setStartDateFilterValue) {
      const newValue = newFiltersObject.startDate
        ? newFiltersObject.startDate.filterVal
        : "";
      props.setStartDateFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageStartDateFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setDurationFilterValue) {
      const newValue = newFiltersObject.duration
        ? newFiltersObject.duration.filterVal
        : "";
      props.setDurationFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageDurationFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setTotalEfficiencyFilterValue) {
      const newValue = newFiltersObject.totalEfficiency
        ? newFiltersObject.totalEfficiency.filterVal
        : "";
      props.setTotalEfficiencyFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageTotalEfficiencyFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setWeightProducedFilterValue) {
      const newValue = newFiltersObject.weightProduced
        ? newFiltersObject.weightProduced.filterVal
        : "";
      props.setWeightProducedFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageWeightProducedFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setHealthFilterValue) {
      const newValue = newFiltersObject.health
        ? newFiltersObject.health.filterVal
        : "";
      props.setHealthFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageHealthFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setAnomaliesFilterValue) {
      const newValue = newFiltersObject.anomalies
        ? newFiltersObject.anomalies.filterVal
        : "";
      props.setAnomaliesFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageAnomaliesFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setWaterUsedFilterValue) {
      const newValue = newFiltersObject.freshWaterUsed
        ? newFiltersObject.freshWaterUsed.filterVal
        : "";
      props.setWaterUsedFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePageWaterUsedFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setPreRinseFreshWaterFilterValue) {
      const newValue = newFiltersObject.preRinseFreshWaterL
        ? newFiltersObject.preRinseFreshWaterL.filterVal
        : "";
      props.setPreRinseFreshWaterFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePagePreRinseFreshWaterFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.setPostRinseFreshWaterFilterValue) {
      const newValue = newFiltersObject.postRinseFreshWaterL
        ? newFiltersObject.postRinseFreshWaterL.filterVal
        : "";
      props.setPostRinseFreshWaterFilterValue(newValue);
      sessionStorage.setItem(
        "beveragesHomePagePostRinseFreshWaterFilterValue",
        JSON.stringify(newValue)
      );
    }
    if (props.isFilterApplied && props.setIsDownloadButtonClicked) {
      props.setIsDownloadButtonClicked(true);
    }
    if (!isObjectsSimilar && props.setFilteredData) {
      props.setFilteredData(newResult);
      setPreviousResult(newResult);
      setPreviousFilterObject(newFiltersObject);
    }
  };

  const columns = props.columns.map((column, index) => {
    return {
      dataField: column.dataField,
      formatter: column.formatter,
      sort: column.sort,
      onSort: column.onSort,
      filter: column.filter,
      sortFunc: column.sortFunc,
      id: index,
      text: column.title,
      hidden: column.hidden,
      headerStyle: headerStyle,
      style: colStyle,
    };
  });

  const paginationOptions = {
    page: props.currentPage ? props.currentPage : 1,
    paginationSize: props.paginationSize || 5,
    pageStartIndex: 1,
    hideSizePerPage: true,
    onPageChange: (page, sizePerPage) => {
      if (props.setCurrentPage) {
        props.setCurrentPage(page);
      }
    },
    hidePageListOnlyOnePage: true,
    sizePerPageList: [
      {
        text: props.pageSize || "5",
        value: props.pageSize || 5,
      },
    ],
  };

  return (
    <>
      {(!props.data || props.isLoading) && props?.data?.length === 0 && (
        <Spinner variant="primary" animation="border" />
      )}
      {props.data && !props.isLoading && (
        <>
          {props.title ? <h5>{props.title}</h5> : null}
          <BootstrapTable
            sort={props.defaultSort}
            rowStyle={props.rowStyle}
            filter={filterFactory({ afterFilter })}
            keyField="id"
            data={props.data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            bootstrap4
            hover
          />
        </>
      )}
    </>
  );
}
